// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const fr: KnowledgePagesCopy = {
  knowledgePage: 'Page de connaissances',
  knowledgePages: 'Pages de connaissances',
  featureOffTitle: 'Les pages de connaissances ne sont pas activées dans cet espace de travail.',
  featureOffBody: 'Le contexte de l’entreprise et les sources restent dans Connaissances.',
  loadingPage: 'Chargement de la page…',
  loadingSuggestion: 'Chargement de la proposition…',
  cancel: 'Annuler',
  tryAgain: 'Réessayer',
  everyoneIn: 'Tout le monde chez {company}',
  yourCompany: 'votre entreprise',
  revision: 'Révision {n}',
  openRevision: 'Ouvrir la révision {n}',
  pageCount: 'one:page|other:pages',
  topicCount: 'one:thème|other:thèmes',
  sectionCount: 'one:section|other:sections',
  lineCount: 'one:ligne|other:lignes',
  documentCount: 'one:document|other:documents',
  changeCount: 'one:modification|other:modifications',
  newPageCount: 'one:nouvelle page|other:nouvelles pages',
  changedPageCount: 'one:page modifiée|other:pages modifiées',
  otherSectionCount: 'one:autre section|other:autres sections',
  characterCount: 'one:caractère|other:caractères',
  diffStats: 'Modifiées : {sections} · ajoutées : {added} · supprimées : {removed}',
  diffMatchesBase: 'Le texte proposé correspond à la révision de base.',
  diffIntroduction: 'Introduction',
  diffOtherUnchanged: '{sections} sans modification.',
  timeJustNow: 'à l’instant',
  originImportedFrom: 'Importée depuis {path}',
  originImportedFromCommit: 'Importée depuis {path} @ {commit}',
  authorityApprovedInPoneva: 'Approuvée dans Poneva',
  authorityImported: 'Importée',
  authorityInRepository: '{canonicality} dans le dépôt',
  authorityVerified: 'vérifiée le {date}',
  authorRepositoryImport: 'Import du dépôt',
  authorSuggestedInChat: 'Proposée dans le chat',
  authorSuggestedInChatWith: 'Proposée dans le chat avec {name}',
  authorSuggestedBy: 'Proposée par {name}',
  authorSuggestedByApp: 'Proposée par une application connectée',
  authorSuggestedByColleague: 'Proposée par un collègue',
  authorSuggestedByYou: 'Proposée par vous',
  authorSuggestedOnBehalf: 'Proposée par {app} pour le compte de {name}',
  authorSuggestedByAppOnBehalf: 'Proposée par une application connectée pour le compte de {name}',
  authorSuggestedAndApproved: 'Proposée et approuvée par {name}',
  approverApprovedBy: 'approuvée par {name}',
  approverAppliedBy: 'appliqué par {name}',
  kindCreatePage: 'Nouvelle page',
  kindUpdatePage: 'Mise à jour proposée',
  kindArchivePage: 'Archivage',
  statusConflict: 'Conflit · page modifiée',
  statusPending: 'En attente d’examen',
  statusApproved: 'Approuvée',
  statusRejected: 'Écartée',
  statusWithdrawn: 'Retirée',
  statusSuperseded: 'Remplacée',
  errRevisionConflict: 'Cette page a changé pendant que vous l’examiniez.',
  errProposalChanged:
    'Cette proposition a changé pendant que vous l’examiniez. Examinez la dernière version avant de décider.',
  errPublishRequired:
    'Seuls les éditeurs de l’entreprise peuvent approuver des modifications des connaissances ou importer des pages.',
  errProposalLimit:
    'Votre entreprise a déjà 200 propositions en attente d’examen. Examinez-en quelques-unes avant d’en proposer d’autres.',
  errAuthorLimit:
    'Vous avez déjà 50 propositions en attente d’examen. Attendez qu’une partie soit tranchée, ou retirez-en quelques-unes, avant d’en proposer d’autres.',
  errImportProposalLimit:
    'Cet import ajouterait plus de pages modifiées à examiner que la file d’examen de votre entreprise ne peut en contenir (200 au maximum). Tranchez quelques propositions dans À examiner, puis appliquez de nouveau.',
  errImportChanged:
    'Cet import n’est pas celui que vous avez examiné. Rouvrez-le et examinez-le avant de l’appliquer.',
  errImportItemNotFound: 'Ce document ne fait plus partie de l’import.',
  errIdempotencyConflict:
    'Cette proposition a déjà été envoyée avec un contenu différent. Rechargez et réessayez.',
  errImportHashMismatch:
    'Un fichier de cet instantané ne correspond pas à sa somme de contrôle enregistrée. Recréez l’instantané et réessayez.',
  errImportAlreadyApplied: 'Cet import a déjà été appliqué.',
  errImportDiscarded: 'Cet import a été abandonné. Choisissez de nouveau le fichier d’instantané.',
  errImportDuplicateItem:
    'Cet instantané contient deux fois le même document. Recréez l’instantané.',
  errInvalidImport:
    'Poneva n’a pas pu accepter cet instantané. Recréez-le avec le script d’instantané et réessayez.',
  errInvalidInput: 'Poneva n’a pas pu accepter cette saisie. Vérifiez les champs et réessayez.',
  errImportLimit:
    'Trop d’imports sont préparés mais pas appliqués. Appliquez-en ou abandonnez-en quelques-uns avant d’en préparer un autre.',
  errPageTooLarge: 'Une page dépasse 256 Ko. Divisez-la en pages plus petites.',
  errTooManySections: 'Une page compte plus de 2 000 titres. Divisez-la en pages plus petites.',
  errPageLimit: 'Votre entreprise a atteint la limite de 2 000 pages de connaissances.',
  errCollectionLimit: 'Votre entreprise a atteint la limite de 100 thèmes.',
  errProposalNotPending: 'Cette proposition a déjà été tranchée. Le statut affiché est à jour.',
  errRequesterRemoved:
    'La personne qui a fait cette proposition ne fait plus partie de cette entreprise ; elle ne peut donc pas être approuvée.',
  errRevisionAlreadyCurrent: 'Cette révision est déjà la révision actuelle.',
  errPageArchived:
    'Cette page a été archivée pendant que vous l’examiniez. Examinez de nouveau la proposition avant de décider.',
  errAlreadyArchived: 'Cette page est déjà archivée.',
  errProposalForbidden: 'Seule la personne qui a fait cette proposition peut la retirer.',
  errUnavailable: 'Les pages de connaissances sont indisponibles pour le moment.',
  errTimeout: 'Poneva a mis trop de temps à répondre.',
  errItemTooLarge: '{path} dépasse 256 Ko. Divisez-le en pages plus petites.',
  errItemTooManySections: '{path} compte plus de 2 000 titres. Divisez-le en pages plus petites.',
  errItemHashMismatch:
    '{path} ne correspond pas à sa somme de contrôle enregistrée. Recréez l’instantané et réessayez.',
  errNoLongerAvailable: 'Cet élément ne vous est plus accessible.',
  errTooLargeToSend: 'Ce fichier est trop volumineux pour être envoyé.',
  cardChecking: 'Vérification du statut…',
  cardNotAvailable: 'Indisponible',
  cardStatusUnavailable: 'Statut indisponible',
  cardUnshowable: 'Cette proposition de mise à jour des connaissances n’a pas pu être affichée.',
  cardEyebrow: 'Proposition de mise à jour des connaissances',
  cardLabel: 'Proposition de mise à jour des connaissances · {title}',
  cardMissing: 'Cette proposition ne vous est plus accessible.',
  cardUnknown:
    'Nous n’avons pas pu vérifier où en est cette proposition. Ouvrez l’examen pour voir son statut.',
  cardCheckAgain: 'Vérifier de nouveau',
  cardReview: 'Examiner la mise à jour',
  statusLineApproved: 'Compréhension approuvée',
  readyCount: 'one:prêt pour la recherche|other:prêts pour la recherche',
  preparingCount: 'one:en préparation|other:en préparation',
  attentionCount: 'one:nécessite une intervention|other:nécessitent une intervention',
  topicsExplore: 'Explorer un thème',
  topicsAllPages: 'Toutes les pages',
  topicsOpenPages: 'Ouvrir Pages',
  topicsEmpty:
    'Aucune page approuvée pour l’instant. Les pages contiennent la compréhension détaillée de l’entreprise, avec tout l’historique de leurs révisions.',
  reviewsTitle: 'Mises à jour de pages proposées',
  reviewsTitleMine: 'Vos mises à jour de pages proposées',
  reviewsIntro:
    'Chaque proposition est une révision candidate complète, avec sa raison et ses preuves. Rien ne change tant que vous n’approuvez pas cette révision précise.',
  reviewsIntroMine:
    'Vos propositions attendent ici qu’un éditeur de l’entreprise les examine. D’ici là, les pages restent telles quelles.',
  loadPagesFailed: 'Nous n’avons pas pu charger les pages de connaissances.',
  loadProposalsFailed: 'Nous n’avons pas pu charger les mises à jour de pages proposées.',
  loadMoreFailed: 'Nous n’avons pas pu charger plus de pages.',
  otherPages: 'Autres pages',
  loadTopicFailed: 'Nous n’avons pas pu charger ce thème.',
  revisionShort: 'r{n}',
  updatedOn: 'Mise à jour le {date}',
  emptyTitle: 'Aucune page de connaissances pour l’instant.',
  emptyBody:
    'Les pages contiennent la compréhension approuvée et détaillée de votre entreprise — orientations, décisions et façons de travailler — en conservant chaque révision. Importez-les depuis un instantané de dépôt ou commencez une page dans le chat ; un éditeur de l’entreprise approuve chaque page avant qu’elle ne fasse partie des connaissances de l’entreprise.',
  importFromSnapshot: 'Importer depuis un instantané de dépôt',
  startInChat: 'Commencer une page dans le chat',
  startInChatPrompt:
    'Aide-moi à commencer une page de connaissances pour notre entreprise. Demande-moi ce qu’elle doit couvrir et n’invente aucun contenu. Elle reste une proposition jusqu’à ce qu’un éditeur de l’entreprise l’approuve.',
  loadingPages: 'Chargement des pages de connaissances…',
  filterLabel: 'Filtrer les pages par titre',
  filterPlaceholder: 'Filtrer les pages',
  importButton: 'Importer',
  showingTopic: 'Thème affiché : {topic}',
  showAllTopics: 'Afficher tous les thèmes',
  loadingTopic: 'Chargement de ce thème…',
  noMatch: 'Aucune page ne correspond à « {filter} ».',
  topicNoPages: 'Aucune page approuvée dans ce thème pour l’instant.',
  loading: 'Chargement…',
  loadMore: 'Charger plus de pages',
  metaApproved: 'approuvée le {date}',
  metaRepositoryAuthoritative: 'le dépôt reste la référence',
  loadPageFailed: 'Nous n’avons pas pu charger cette page.',
  loadHistoryFailed: 'Nous n’avons pas pu charger l’historique des révisions.',
  outlineLabel: 'Sections de la page',
  outlineToggle: 'Sur cette page',
  loadingHistory: 'Chargement de l’historique des révisions…',
  historyLabel: 'Historique des révisions',
  historyIntro:
    'Chaque révision approuvée est conservée. Restaurer une révision antérieure crée une proposition à examiner ; cela n’efface jamais les révisions ultérieures.',
  historyCurrent: 'Actuelle',
  historyViewing: 'Affichée',
  historyView: 'Afficher',
  historyViewAria: 'Afficher la révision {n}',
  restoreAria: 'Restaurer sous forme de proposition : révision {n}',
  restoreCreating: 'Création de la proposition…',
  restore: 'Restaurer sous forme de proposition',
  restoreUnconfirmed:
    'Nous n’avons pas pu confirmer la création de la proposition. Vérifiez À examiner avant de réessayer.',
  editTooLarge: 'Cette page dépasse 256 Ko. Divisez-la en pages plus petites avant de la proposer.',
  editConflict:
    'Cette page a changé pendant que vous la modifiiez. Copiez votre texte, ouvrez la dernière révision et proposez de nouveau la modification.',
  editUnconfirmed:
    'Nous n’avons pas pu confirmer l’envoi de votre proposition. Vérifiez À examiner avant de l’envoyer de nouveau.',
  editHeading: 'Proposer une modification',
  editIntro:
    'Vous modifiez la révision {n}. Un éditeur de l’entreprise examine la modification exacte avant qu’elle ne devienne la révision {next} ; d’ici là, la page reste telle quelle.',
  editOutdated:
    'Une révision plus récente a été approuvée pendant que vous modifiiez la page. Copiez votre texte, puis recommencez à partir de la dernière révision pour ne rien perdre de ce qu’elle a changé.',
  editContentLabel: 'Contenu de la page (Markdown)',
  editReasonLabel: 'Pourquoi cette modification ?',
  editReasonPlaceholder: 'Ce qui a changé, et d’où cela vient.',
  editSending: 'Envoi…',
  editSend: 'Envoyer pour examen',
  editDiscardConfirm:
    'Abandonner cette modification ? Rien de ce que vous avez changé n’a été envoyé.',
  editNoChanges: 'Aucune modification pour l’instant.',
  editNeedsContent: 'Une page doit avoir du contenu.',
  exportFailed: 'Nous n’avons pas pu exporter cette page. Réessayez.',
  askPagePrompt: 'Question sur la page de connaissances « {title} » (révision {n}, {link}) :',
  askPageSectionPrompt:
    'Question sur la page de connaissances « {title} » § {section} (révision {n}, {link}) :',
  pageMissingTitle: 'Cette page n’est pas disponible.',
  pageMissingBody:
    'Elle a peut-être été archivée, ou vous n’avez peut-être plus accès aux connaissances de cette entreprise.',
  pageArchived: 'Archivée',
  viewingRevisionCurrent: 'Vous consultez la révision {n} ; la révision actuelle est la {current}.',
  viewingRevisionOld: 'Vous consultez la révision {n}. Ce n’est pas la révision actuelle.',
  openCurrent: 'Ouvrir l’actuelle',
  archivedBanner:
    'Cette page est archivée. Elle n’alimente plus les réponses ; son historique est conservé.',
  pageViewsLabel: 'Vues de la page',
  tabRead: 'Lire',
  tabHistory: 'Historique',
  unknownSection:
    'La section liée ne fait pas partie de cette révision. Affichage de la page entière.',
  askAboutPage: 'Poser une question sur cette page',
  exporting: 'Exportation…',
  exportMarkdown: 'Exporter en Markdown',
  loadSuggestionFailed: 'Nous n’avons pas pu charger cette proposition.',
  evidenceSource: 'Source',
  evidenceFact: 'Contexte de l’entreprise',
  evidenceResult: 'Travail enregistré',
  evidenceUrl: 'Page web',
  evidenceDecision: 'Décision',
  evidenceReference: 'Référence',
  evidenceOpenPage: 'Ouvrir la page de connaissances',
  evidenceOpenSource: 'Ouvrir la source',
  evidenceOpenFact: 'Ouvrir le contexte de l’entreprise',
  evidenceOpenResult: 'Ouvrir le travail enregistré',
  evidenceOpenUrl: 'Ouvrir la page web',
  evidenceOpenDecision: 'Ouvrir la décision',
  evidenceOpenReference: 'Ouvrir la référence',
  evidenceDecisionNote: 'Une décision enregistrée. Il n’y a rien à ouvrir dans Poneva.',
  evidenceFactGone: 'Ce contexte de l’entreprise n’est plus enregistré.',
  evidencePageNoRevision: 'Cette page n’a aucune révision approuvée à ouvrir.',
  evidencePrivateExcerpt: 'Preuve privée — seul l’extrait ci-dessus a été partagé.',
  evidencePrivate: 'Preuve privée — son contenu ne vous a pas été partagé.',
  evidenceHeading: 'Preuves',
  evidenceNone: 'Aucune preuve n’a été jointe. Évaluez la raison ci-dessus pour elle-même.',
  changeAdded: 'Ajoutée',
  changeRemoved: 'Supprimée',
  changeChanged: 'Modifiée',
  changeUnchanged: 'Inchangée',
  moreLineCount: 'one:autre ligne|other:autres lignes',
  moreUnchangedLineCount: 'one:autre ligne inchangée|other:autres lignes inchangées',
  unchangedLineCount: 'one:ligne inchangée|other:lignes inchangées',
  skipAdded: '{lines} — à voir dans la révision complète',
  skipRemoved: 'Suppression : {lines}',
  cutUnchanged: '{lines} hors affichage',
  cutChanged: '{lines} hors affichage ; {changes}. Vérifiez-les dans la révision complète.',
  cutAddedRemoved: 'ajouts : {added}, suppressions : {removed}',
  cutAdded: 'ajouts : {added}',
  cutRemoved: 'suppressions : {removed}',
  lineAddedSr: 'Ajout :',
  lineRemovedSr: 'Suppression :',
  noLinesAdded: 'Une nouvelle section. Son texte figure dans la révision complète ci-dessous.',
  noLinesRemoved: 'Cette section serait supprimée de la page.',
  noLinesChanged: 'Cette section change. Son texte figure dans la révision complète ci-dessous.',
  diffHeading: 'Modifications',
  outcomeArchived: 'Archivée.',
  outcomeArchivedBody:
    '{title} n’alimente plus les réponses et a quitté la liste des pages. Ses révisions, cette proposition et la décision restent dans l’historique de la page.',
  openArchivedPage: 'Ouvrir la page archivée',
  outcomeApproved: 'Approuvée.',
  outcomeApprovedRevision: 'La révision {n} est désormais la version approuvée de {title}.',
  outcomeApprovedPlain: 'Cette proposition a été approuvée.',
  outcomeRestored:
    'La page est de retour dans la liste des pages et alimente de nouveau les réponses.',
  outcomeKept:
    'La proposition, la décision et toutes les révisions antérieures restent dans l’historique de la page.',
  openPage: 'Ouvrir la page',
  outcomeDismissed: 'Écartée.',
  outcomeWithdrawn: 'Retirée.',
  outcomeSuperseded: 'Remplacée.',
  outcomeSupersededBody:
    'Une révision, une proposition ou un import du dépôt plus récent a rendu cette proposition obsolète. Elle n’a rien changé par elle-même.',
  outcomeUnchanged: 'La page reste telle quelle.',
  approveNewPage: 'Approuver la nouvelle page',
  approveArchive: 'Approuver l’archivage',
  approveRestoreRevision: 'Restaurer et approuver la révision {n}',
  approveRevision: 'Approuver la révision {n}',
  approveArchiveNote: 'L’approbation archive cette page pour tout le monde chez {company}.',
  approvePublishNote: 'L’approbation publie cette révision pour tout le monde chez {company}.',
  approvePublishEvidenceNote:
    'L’approbation publie cette révision et les extraits de preuves affichés ci-dessus pour tout le monde chez {company}.',
  archivedTitle: 'Cette page est archivée.',
  alreadyArchivedBody:
    'L’approbation ne changerait rien ; cette proposition peut donc seulement être écartée.',
  archivedRestoreBody:
    'L’approbation la restaure : la page revient dans la liste des pages, la recherche et les réponses avec cette révision.',
  staleRevisionAction: 'Comparer avec la dernière version',
  staleProposalTitle: 'Cette proposition a changé pendant que vous l’examiniez.',
  staleProposalAction: 'Examiner la dernière version',
  staleArchivedTitle:
    'Cette page a été archivée pendant que vous l’examiniez. Approuver cette proposition la rétablirait.',
  staleArchivedAction: 'Examiner de nouveau',
  suggestionMissingTitle: 'Cette proposition n’est pas disponible.',
  suggestionMissingBody:
    'Elle a peut-être été retirée, ou elle appartient à quelqu’un d’autre et n’a pas été envoyée pour examen par l’entreprise.',
  decideUnconfirmed:
    'Nous n’avons pas pu confirmer votre décision. Le statut affiché est le plus récent fourni par Poneva ; vérifiez-le avant de réessayer.',
  decideFailed: 'Nous n’avons pas pu enregistrer votre décision.',
  discussPrompt:
    'Aide-moi à affiner la proposition de mise à jour des connaissances pour « {title} » ({link}).',
  conflictBody:
    'Cette proposition a été rédigée à partir de la révision {base} ; la révision actuelle est la {current}. L’approuver écraserait cette modification ; elle ne peut donc pas être approuvée en l’état.',
  conflictBodyPlain:
    'Cette proposition a été rédigée à partir d’une révision antérieure ; elle ne peut donc pas être approuvée en l’état.',
  openLatest: 'Ouvrir la dernière version',
  reworkInChat: 'Retravailler dans le chat',
  factReason: 'Raison',
  factNoReason: 'Aucune raison n’a été donnée.',
  factAudience: 'Public',
  factRevision: 'Révision',
  revisionNew: 'Une nouvelle page, révision 1',
  revisionArchiveAfter: 'Archivage après la révision {n}',
  revisionWrittenAgainst:
    'Rédigée à partir de la révision {base} ; la révision actuelle est la {current}',
  revisionCurrentToProposed: 'Révision actuelle {base} → révision proposée {next}',
  revisionProposed: 'Révision proposée {next}',
  proposedPage: 'Page proposée',
  archivingHeading: 'Effet de l’archivage',
  archivingBody:
    'La page cesse d’alimenter les réponses et quitte la liste des pages. Ses révisions et cette décision sont conservées.',
  noComparison: 'Aucune comparaison par section n’est disponible pour cette proposition.',
  showComplete: 'Afficher la révision complète',
  approving: 'Approbation…',
  dismissing: 'Mise à l’écart…',
  dismiss: 'Écarter',
  withdrawing: 'Retrait…',
  withdraw: 'Retirer',
  editInChat: 'Modifier dans le chat',
  waitingForPublisher: 'En attente de l’examen par un éditeur de l’entreprise.',
  snapshotTooLarge: 'Cet instantané dépasse 8 Mo. Recréez-le avec moins de documents.',
  snapshotNotSnapshot:
    'Ce fichier n’est pas un instantané de connaissances. Choisissez le fichier JSON généré par le script d’instantané.',
  snapshotEmpty: 'Cet instantané ne contient aucun document.',
  readDocumentFailed: 'Nous n’avons pas pu lire ce document. Réessayez.',
  readingDocument: 'Lecture du document…',
  hideText: 'Masquer le texte',
  readText: 'Lire le texte',
  textOf: 'Texte de {title}',
  gitSnapshot: 'Instantané Git {commit}',
  repositorySnapshot: 'Instantané de dépôt',
  importNewHeading: '{pages} · approbation dès l’application',
  importNewNote:
    'Chacune est publiée comme page approuvée pour tout le monde chez {company}, sans autre examen. Lisez-les une à une avant d’appliquer.',
  importChangedHeading: '{pages} · envoi pour examen',
  importChangedNote:
    'Chacune devient une proposition de mise à jour. Sa page ne change que lorsqu’un éditeur de l’entreprise l’approuve dans À examiner, qui montre ce qui a changé.',
  unchangedDocumentCount: 'one:document inchangé|other:documents inchangés',
  unchangedNote:
    'Ces documents correspondent déjà à leurs pages approuvées. Rien n’est écrit pour eux.',
  stagedHeading: 'Préparé mais pas appliqué',
  excludedSummary: '{documents} hors de cet instantané',
  countsLine: '{newPages} · {changedPages} à examiner · sans changement : {unchanged}',
  importAlreadyDiscarded: 'Cet import a déjà été abandonné.',
  confirmLabel: 'Confirmer l’import',
  unchangedKeepCount:
    'one:document inchangé conserve sa page|other:documents inchangés conservent leurs pages',
  confirmBody:
    'Appliquer cet import pour tout le monde chez {company} ? Approbation en révision 1 : {newPages} ; en attente d’examen : {changedPages} ; enfin, {unchanged}. Les propositions d’import antérieures pour ces pages sont retirées.',
  applying: 'Application…',
  applyImport: 'Appliquer l’import',
  chooseAnother: 'Choisir un autre fichier',
  allCurrent: 'Tout le contenu de cet instantané est déjà à jour.',
  importApplied: 'Import appliqué.',
  appliedSummary:
    'Création : {pages} · en attente d’examen : {changes} · sans changement : {unchanged}.',
  appliedIndexing:
    'Les nouvelles pages deviennent consultables dans le chat une fois l’indexation terminée. La préparation des sources indique la progression.',
  openPages: 'Ouvrir les pages',
  reviewChanges: 'Examiner {changes}',
  checkIndexing: 'Vérifier la progression de l’indexation',
  sendSnapshotFailed: 'Nous n’avons pas pu envoyer cet instantané. Réessayez.',
  openStagedFailed: 'Nous n’avons pas pu ouvrir cet import préparé.',
  applyUnconfirmed:
    'Nous n’avons pas pu confirmer si l’import a été appliqué. Vérifiez Pages avant de réessayer.',
  applyFailed: 'Nous n’avons pas pu appliquer cet import.',
  importHeading: 'Importer des pages depuis le dépôt',
  backToPages: 'Retour aux pages',
  importLead:
    'Créez un instantané avec {command}, puis choisissez le fichier. Vous verrez chaque document et ce qu’il changerait avant que quoi que ce soit ne soit enregistré.',
  snapshotFileLabel: 'Fichier d’instantané de connaissances',
  readingSnapshot: 'Lecture de l’instantané…',
  openingStaged: 'Ouverture de l’import préparé…',
  chooseSnapshot: 'Choisir le fichier d’instantané',
  factOrigin: 'Origine',
  factContents: 'Contenu',
  importOnlyListed: 'Seuls les documents listés ici sont importés.',
  importRepositoryAuthoritative:
    'Le dépôt reste la référence ; les documents modifiés deviennent des propositions à examiner.',
  overviewReviewChanges: 'Examiner les modifications',
  overviewConnectAgents: 'Connecter des agents externes',
  overviewEyebrow: 'Une compréhension partagée',
  overviewTitle: '{company}, en contexte.',
  overviewLeadFallback:
    'Les connaissances de votre entreprise commencent par le contexte que vous partagez. Construisons ensemble une compréhension de votre activité.',
  overviewBody:
    'Le contexte de l’entreprise et les sources donnent à Poneva un point de départ — pas tout ce qu’il y a à savoir sur {company}. Continuez à enrichir cette compréhension à mesure que votre activité évolue.',
  overviewAskPrompt: 'Que sais-tu de notre entreprise, et qu’est-ce qu’il serait utile d’ajouter ?',
  overviewAsk: 'Poser une question sur {company}',
  overviewAddSources: 'Ajouter des sources',
  contextEyebrow: 'Ce qui donne du contexte aux réponses',
  contextTitle: 'L’entreprise derrière la question.',
  contextBody:
    'Les sources web décrivent l’activité publique. Les notes de l’entreprise ajoutent votre terminologie, vos priorités et votre façon de travailler.',
  contextPrompt:
    'Aide-moi à clarifier les priorités de l’entreprise et les préférences de travail dont nous devrions nous souvenir.',
  contextAction: 'Construire notre compréhension',
  learnEyebrow: 'De la place pour apprendre',
  learnTitle: 'Commencez par ce qui compte ensuite.',
  learnBody:
    'Apportez des sources ou précisez comment fonctionne votre entreprise. Poneva peut proposer des changements durables que vous examinerez.',
  learnPrompt:
    'D’après les connaissances actuelles de notre entreprise, quelles informations importantes manquent pour le travail que nous voulons faire ?',
  learnAction: 'Discuter de ce qui serait utile',
  canvasEmptyTitle: 'Un peu de contexte suffit à faire beaucoup.',
  canvasEmptyBody:
    'Le profil de votre entreprise est le point de départ. Ajoutez des sources et des notes examinées pour aider Poneva à comprendre votre travail.',
  pageEyebrow: 'Espace de travail {company}',
  pageTitle: 'Connaissances de l’entreprise',
  pageDescription: 'Les sources et la compréhension qui sous-tendent le travail de Poneva.',
  tabOverview: 'Vue d’ensemble',
  tabPages: 'Pages',
  tabSources: 'Sources',
  tabReview: 'À examiner',
  proposalApproved: 'Contexte de l’entreprise approuvé',
  proposalDismissed: 'Proposition écartée',
  proposalRemoval: 'Suppression proposée',
  proposalCorrection: 'Correction proposée',
  proposalContext: 'Contexte de l’entreprise proposé',
  proposalCurrent: 'Compréhension actuelle',
  proposalFactGone:
    'Le fait enregistré n’est plus disponible. Actualisez les connaissances de l’entreprise avant d’examiner cette suppression.',
  proposalReviewFallback: 'Examinez le contexte de l’entreprise proposé.',
  proposalNotSaved: 'Pas encore enregistré. Les sources d’origine restent inchangées.',
  proposalWaiting:
    'En attente d’examen · un éditeur de l’entreprise décide dans sa Boîte de réception',
  proposalSaving: 'Enregistrement…',
  proposalApproveRemoval: 'Approuver la suppression',
  proposalApproveClarification: 'Approuver la clarification',
  factLabel: 'Fait de l’entreprise',
  factEyebrow: 'Fait · Tout le monde chez {company}',
  factSuggestCorrection: 'Proposer une correction',
  factAskPrompt:
    'Aide-moi à comprendre ou à clarifier ce contexte enregistré de l’entreprise : « {content} »',
  factAsk: 'Poser une question à ce sujet',
  companyContextHeading: 'Contexte de l’entreprise',
  companyContextPrompt:
    'J’aimerais clarifier les connaissances de notre entreprise. Aide-moi à passer en revue ce que nous savons et à proposer une mise à jour.',
  companyContextEmpty:
    'Aucune note approuvée pour l’instant. Lancez une conversation sur votre entreprise ou ajoutez des sources ci-dessous.',
  refineInChat: 'Affiner dans le chat',
  reviewPanelLabel: 'Modifications des connaissances à examiner',
  suggestedUpdatesHeading: 'Mises à jour proposées',
  suggestedUpdatesIntro:
    'Propositions issues de vos conversations. Vous décidez de ce qui entre durablement dans les connaissances de votre entreprise.',
  reviewEmptyTitle: 'Rien n’attend votre examen.',
  reviewEmptyBody:
    'Lorsque Poneva propose une modification des connaissances de votre entreprise, vous la trouverez ici. Les changements durables nécessitent toujours votre approbation.',
  reviewEmptyPrompt:
    'Aide-moi à examiner les connaissances de notre entreprise et propose ce qu’il serait utile de clarifier ensuite.',
  inclusionPendingApproval:
    'Modification de l’inclusion dans les connaissances envoyée pour approbation.',
  sourcesFileIncluded:
    'Fichier inclus dans la recherche des connaissances pour son audience actuelle.',
  sourcesAddFailed: 'Impossible d’ajouter cette source.',
  sourcesHeading: 'Les documents derrière les réponses.',
  sourcesIntro:
    'Poneva effectue ses recherches dans l’intégralité des sources, pas seulement dans la vue d’ensemble. Conservez les originaux, voyez ce qui est prêt et choisissez ce qui alimente vos réponses.',
  addSourceHeading: 'Ajouter des documents de votre entreprise',
  addSourceIntro:
    'Les sources importées restent privées dans votre Bibliothèque et n’alimentent que vos propres réponses. Choisissez Partager lorsque vous voulez les mettre à la disposition de vos collègues.',
  uploadSource: 'Importer une source',
  addSourcePrompt:
    'Aide-moi à ajouter une déclaration de l’entreprise comme source interne partagée. Demande-moi ce que je souhaite consigner ; n’invente aucun contenu. Les changements durables de la compréhension de l’entreprise nécessitent toujours mon approbation.',
  addThroughChat: 'Ajouter via le chat',
  addingSource: 'Ajout…',
  addToKnowledge: 'Ajouter aux connaissances',
  uploadFormats: 'TXT, Markdown, CSV et JSON · Jusqu’à 5 Mo par fichier',
  sourceExcluded: 'Exclue des réponses',
  sourcePreparationFailed: 'Échec de la préparation',
  sourcePreparing: 'Préparation pour la recherche',
  sourceWaiting: 'En attente de préparation',
  sourceReadinessUnknown: 'État de préparation indisponible',
  sourceRetryQueued:
    'Préparation mise en file d’attente. L’état de préparation sera mis à jour une fois celle-ci terminée.',
  sourceIncludedNotice: 'Source incluse. Poneva va la préparer pour la recherche.',
  sourceExcludedNotice: 'Exclue des réponses. La source d’origine est conservée.',
  sourceUpdateFailed: 'Impossible de mettre à jour cette source.',
  sourceOriginalMaterial: 'Document source d’origine',
  sourceDiscuss: 'En discuter dans le chat',
  sourceDiscussPrompt: 'Aide-moi à comprendre ou à clarifier « {title} ».',
  sourceExclude: 'Exclure des réponses',
  sourceInclude: 'Inclure dans les réponses',
  sourcesLoadFailed: 'Nous n’avons pas pu charger vos sources.',
  sourceLibraryLabel: 'Bibliothèque de sources de l’entreprise',
  sourceListCaption: 'Sources d’origine · incluses et exclues',
  sourceSearchLabel: 'Rechercher dans les sources de l’entreprise',
  sourceSearchPlaceholder: 'Rechercher dans vos sources…',
  sourcesFinding: 'Recherche de vos sources…',
  sourcePagesLabel: 'Pagination des sources',
  sourceRange: '{from}–{to} sur {count}',
  sourceCount: 'one:source|other:sources',
  sourcePrevious: 'Précédent',
  sourceNext: 'Suivant',
  sourceNoMatchTitle: 'Aucune source correspondante.',
  sourceNoMatchBody: 'Essayez une autre expression ou un autre nom de source.',
  sourceEmptyTitle: 'Donnez à vos questions un point de départ plus solide.',
  sourceEmptyBody:
    'Ajoutez des documents de l’entreprise, des données produit ou des notes de travail. Poneva peut utiliser l’intégralité des sources dans les conversations et les Skills.',
  indexCheckFailed: 'Nous n’avons pas pu vérifier la préparation des sources.',
  indexRetryQueued:
    'Les entrées de connaissances en échec ont été mises en file d’attente pour préparation. Vos sources restent inchangées.',
  indexQueueFailed: 'Nous n’avons pas pu mettre la préparation en file d’attente. Réessayez.',
  indexPreparing: 'Préparation de nouvelles connaissances pour vos conversations…',
  indexAttention: 'Certaines connaissances nécessitent une intervention.',
  queuing: 'Mise en file d’attente…',
  retryPreparation: 'Relancer la préparation',
  sourceKindStatement: 'Déclaration de l’entreprise',
  sourceKindWebsite: 'Site web',
  sourceKindDocument: 'Document',
  factAnswers: 'one:réponse|many:réponses|other:réponses',
  factUsedThisWeek: 'Utilisé dans {answers} cette semaine',
  factLastUsed: 'dernière utilisation : {when}',
  factToday: 'aujourd’hui',
  factYesterday: 'hier',
  factImpact: 'Cette modification touche un fait utilisé dans {answers} cette semaine.',
  factCorrectionAbout: 'À propos de ce fait de l’entreprise : « {content} » ({link})',
  factCorrectionOutdated: 'Ce n’est plus à jour :',
  sourceCanvasRecorded: 'Source enregistrée',
  sourceCanvasNotIncluded:
    'Non inclus dans les connaissances de l’entreprise. L’original est conservé pour référence et peut toujours être utilisé dans une conversation précise.',
  sourceCanvasOpenOriginal: 'Ouvrir la source originale',
  sourceCanvasUnavailable: 'Le contenu de la source n’est pas disponible.',
  sourceCanvasDiscussPrompt: 'Aide-moi à comprendre ou à clarifier « {title} ».',
  sourceCanvasDiscuss: 'Discuter de cette source',
  sourceCanvasCorrectionNote:
    'Une correction devient un contexte de l’entreprise proposé. La source enregistrée reste inchangée.',
  contextCanvasEyebrow: 'Contexte de l’entreprise disponible',
  contextCanvasTitle: 'Les connaissances derrière cette conversation.',
  contextCanvasBody:
    'La compréhension approuvée et les sources ajoutées par votre entreprise. Disponibles dans le chat et dans Skills.',
  contextCanvasOpen: 'Ouvrir Connaissances',
};

export default fr;
